// extracted by mini-css-extract-plugin
module.exports = {"container":"Pill_container__2FFAI","label":"Pill_label__18h2F","button":"Pill_button__10bjc","spin360":"Pill_spin360__1ZS81"};